const sideprojects = {
    bg: `contentBg`,
    borderRadius: `full`,
    transition: `
      transform 250ms ease,
      box-shadow 250ms ease,
      color 250ms ease
    `,
    display: `flex`,
    flexDirection: `column`,
    p: 4,


    '@media (hover: hover) and (pointer: fine)': {
        ':hover': {
          transform: `translateY(-0.25rem)`,
        }
      }
  }
  
  export default sideprojects